/**
 * Extended ChMSTheme with additional color mappings for @pushpay/table compatibility
 * 
 * The @pushpay/table component expects shorthand color keys (e.g., 'grey-200')
 * while ChMSTheme uses descriptive DSM tokens (e.g., 'palette-grey-light-200').
 * This extension maps the expected keys to the appropriate ChMSTheme colors.
 * 
 * @see TABLE_THEME_COMPATIBILITY.md for full analysis
 */

import { ChMSTheme } from '@pushpay/theming';

export const ExtendedChMSTheme = {
  ...ChMSTheme,
  colors: {
    ...ChMSTheme.colors,
    
    // Grey shades for table headers and sort states
    'grey-200': ChMSTheme.colors['palette-grey-light-200'], // #E3E5E9 - Default header background
    'grey-300': ChMSTheme.colors['palette-grey-light-300'], // #F1F1F5 - Sortable header hover
    'grey-400': ChMSTheme.colors['palette-grey-light-400'], // #F5F6FA - Currently sorted column
    'grey-500': ChMSTheme.colors['palette-grey'],           // #AEB1B5 - Sort icon color
    
    // Blue shade for selected/highlighted cells
    'blue-100': ChMSTheme.colors['palette-blue-light-400'], // #ECF6FD - Cell selection highlight
    
    // Transparent for row actions column
    'common-transparent': ChMSTheme.colors['palette-transparent'], // transparent
  }
};
